export default (id) => {
  const optionMenuElement = document.getElementById(id);

  if (optionMenuElement.style.display === 'none') {
    optionMenuElement.style.display = 'flex';
  } else {
    optionMenuElement.style.display = 'none';
  }
};
